import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './TwoBannersCentered.scss';

const TwoBannersCentered = ({data, context}) => {
  const handleButtonClick = (link) => {
    if (link) {
      console.log('Navigating to:', link);
      context.navigateTo(link);
    }
  };

  return (
    <div className="two-banners-centered">
      <div className="right-banner" style={{ backgroundColor: data.mainBackgroundColor }}>
        <div className="right-banner-bg">
          {data.mainBackground && data.mainBackgroundType === 'video' && (
            <video autoPlay loop muted playsInline>
              <source src={data.mainBackground} type="video/mp4" />
            </video>
          )}
          {data.mainBackground && (data.mainBackgroundType === 'image' || data.mainBackgroundType === 'gif') && (
            <Image src={data.mainBackground} alt="Right Banner" />
          )}
        </div>
        <div className="right-banner-text">
          <div className="right-banner-main-text" style={{ color: data.mainTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.mainText}} />
          {data.additionalText && (
            <div className="right-banner-additional-text" style={{ color: data.additionalTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.additionalText}} />
          )}
          {data.secondaryText && (
            <div className="right-banner-secondary-text" style={{ color: data.secondaryTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.secondaryText}} />
          )}
        </div>
        {data.mainButton?.text && data.mainButton?.link && (
          <button
            className={`right-banner-button banner-button banner-button--${data.mainButton.style}`}
            onClick={() => handleButtonClick(data.mainButton.link)}>
            <span>{data.mainButton.text}</span>
          </button>
        )}
      </div>
      <div className="left-banner" style={{ backgroundColor: data.secondaryBanner?.backgroundColor }}>
        <div className="left-banner-bg">
          {data.secondaryBanner?.background && data.secondaryBanner?.backgroundType === 'video' && (
            <video autoPlay loop muted playsInline>
              <source src={data.secondaryBanner.background} type="video/mp4" />
            </video>
          )}
          {data.secondaryBanner?.background && (data.secondaryBanner?.backgroundType === 'image' || data.secondaryBanner?.backgroundType === 'gif') && (
            <Image src={data.secondaryBanner.background} alt="Left Banner" />
          )}
        </div>
        <div className="left-banner-text">
          <div className="left-banner-main-text" style={{ color: data.secondaryBanner?.mainTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.secondaryBanner?.mainText}} />
          {data.secondaryBanner?.additionalText && (
            <div className="left-banner-additional-text" style={{ color: data.secondaryBanner.additionalTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.secondaryBanner.additionalText}} />
          )}
          {data.secondaryBanner?.secondaryText && (
            <div className="left-banner-secondary-text" style={{ color: data.secondaryBanner?.secondaryTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.secondaryBanner.secondaryText}} />
          )}
        </div>
        {data.secondaryBanner?.button?.text && data.secondaryBanner?.button?.link && (
          <button
            className={`left-banner-button banner-button banner-button--${data.secondaryBanner.button.style}`}
            onClick={() => handleButtonClick(data.secondaryBanner.button.link)}>
            <span>{data.secondaryBanner.button.text}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default TwoBannersCentered;

